import { type ProductConfigurationMap } from '../../types';

import { isFedRamp } from '@atlassian/atl-context';
import { formatLabel } from '../providers/product-configuration-provider';
import messages from './messages';

export const buildRovoScasProducts = (productConfigurationMap: ProductConfigurationMap) => {
	const configMap = { ...productConfigurationMap };
	if (isFedRamp()) {
		return configMap;
	}

	configMap.SEARCH = {
		label: formatLabel(messages.search),
		iconKey: 'search',
		key: 'search',
		ordinal: 20,
	};
	configMap.CHAT = {
		label: formatLabel(messages.chat),
		iconKey: 'chat',
		key: 'chat',
		ordinal: 21,
	};
	configMap.STUDIO = {
		label: formatLabel(messages.studio),
		iconKey: 'studio',
		key: 'studio',
		ordinal: 22,
	};

	return configMap;
};
